import { createAuthClient } from 'better-auth/react';
import { organizationClient } from 'better-auth/client/plugins';

/**
 * Better-Auth React client. Talks to /api/auth/* on the same origin where this
 * SPA is hosted — which is the Pages Function at `functions/api/auth/[[catchall]].ts`.
 */
export const authClient = createAuthClient({
  baseURL: typeof window !== 'undefined' ? window.location.origin : 'http://localhost:3000',
  plugins: [organizationClient()],
});

export const { useSession, signIn, signUp, signOut } = authClient;
